import { object } from "yup/lib/locale";



export class Product{
    productId= 0;
    campaignId= 0;
    productName= null;
    campaignShowFlag= 0;
    campaignText= null;
    badgeText= null;
    packageType= null;
    content= 0.0;
    oldPriceShowFlag= 0;
    oldPrice= null;
    price= 0.0;
    productImages:ProductImage[]=[]
    oldPriceStrikeFlag= 0;
    perContentWeigth= 0.0;
    weightUnit= null;
    startDate=null;
    endDate= null;
    campaignTargets= null;
    taxRate= 0;
    relatedStorePrices= null;
    productStockStatus= 0;
    stockQuantity= 0
}

export class ProductList{
    currentPageNumber=1
    pageCount=0
    pageSize=100
    totalRowsCount=0
    results:Product[] = []
}

export class ProductImage{
    Cdn_url="";
    Cdn_oo2_url="";
    Descript= null;
    productId= 0

};
export class infoData{
    key="";
    value="";
};
export class relatedStorePrices{
    storeNo= 0;
    storeName= null;
    price=0.0;
    productStockStatus=1;
    stockQuantity=0;
};
export class ProductDetail {
    productBatches= [];
    productLogos= null;
    productImages: ProductImage[]=[];
    puarNo= 0;
    puarInfoText= null;
    productCode= null;
    productStockStatus= 0;
    productHeight= 0;
    productWidth= 0;
    ProductDepth= 0;
    filterBrand= 0;
    filterBrandName= null;
    filterCategory= 0;
    filterCategoryName= null;
    relatedProductList= null;
    infoData: infoData[]=[];
    campaignAnnouncement= null;
    shoppingListItemCount= 0;
    relatedStorePrices:relatedStorePrices[]= [];
    productId= 0;
    campaignId= 0;
    productName= null;
    campaingShowFlag= 0;
    campaingText= null;
    badgeText= null;
    oldPriceShowFlag= 0;
    promotionStockLimit= 0;
    oldPrice= 0.0;
    price= 0.0;
    unitPrice= 0.0;
    content= 0.0;
    packageType= null;
    startDate= null;
    endDate= null;
    salesBundle= 0;
    countryOrigin= null;
    taxRate= 0;
    productDescription= null;
    productCertifications= null;
    nutritiveValue= null;
    ingredients= null;
    oldPriceStrikeFlag= 0;
    perContentWeigth= 0.0;
    weightUnit= 0;
    subsystemNumber= 0;
    campaignTypeId= 0
   
}
export class ProductModel{
    productDetail= new ProductDetail;
}
export class ProductListModel{
    productList= new ProductList;
}

export class BaseStore{
    store = new StoreModel
}

export class StoreModel{
    storeNo = 0
    storeName = ""
}

export class StoreList{
    storeList:StoreModel[] = []
}